import {
  ALL,
  ALL_OPTIONS,
  SET_CURRENT_PAGE,
  SET_CURRENT_PAGE_USER,
  GET_SELECTED_PERIMETER,
  ALL_USERS,
} from './mutation-types';

export default {
  /**
   * Mutation to update the store with the fetched perimeters.
   *
   * @param {Object} state      The current state of the store.
   * @param {Object}  perimeters The fetched perimeters.
   * @param {Object} pagination The fetched pagination.
   */

  [ALL](state, { perimeters, pagination }) {
    state.all = perimeters;
    Object.keys(pagination).forEach((key) => {
      state.pagination[key] = pagination[key];
    });
  },

  /**
   * Mutation to update the store with the fetched options.
   *
   * @param {Object} state   The current state of the store.
   * @param {Object} options The fetched options.
   */

  [ALL_OPTIONS](state, { options }) {
    state.allOptions = options;
  },

  [SET_CURRENT_PAGE](state, currentPage) {
    state.pagination.currentPage = currentPage;
  },

  [SET_CURRENT_PAGE_USER](state, currentPage) {
    state.paginationUsers.currentPage = currentPage;
  },

  /**
   * Mutation to update the store with the fetched perimeter.
   *
   * @param {Object} state             The current state of the store.
   * @param {Object} selectedPerimeter The fetched perimeter.
   */
  [GET_SELECTED_PERIMETER](state, selectedPerimeter) {
    state.selectedPerimeter = selectedPerimeter;
  },


  /**
   * Mutation to update the store with the fetched users.
   *
   * @param {Object} state      The current state of the store.
   * @param {Object} users      The fetched users.
   * @param {Object} pagination The fetched pagination.
   */

  [ALL_USERS](state, { users, pagination }) {
    state.allUsers = users;
    Object.keys(pagination).forEach((key) => {
      state.paginationUsers[key] = pagination[key];
    });
  },


};



// WEBPACK FOOTER //
// ./src/store/modules/perimeters/mutations.js